import { type FC, useState, PropsWithChildren } from 'react';
import { resetPassword } from '@frontend/auth';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Modal, EmailField, ContentLoader, useFormField, useAlert } from '@frontend/design-system';

type Props = {
  modalProps: any;
};

export const PasswordReset: FC<PropsWithChildren<Props>> = ({ modalProps }) => {
  const { t } = useTranslation('SignIn');
  const alerts = useAlert();
  const fieldProps = useFormField({ type: 'email', required: true });

  const [isLoading, setIsLoading] = useState(false);

  async function handleResetPassword() {
    const email = fieldProps.value;
    fieldProps.value = '';

    setIsLoading(true);
    try {
      await resetPassword(email);
      alerts.success(`${t('The reset password has been sent to')} ${email}`);
    } catch (err) {
      alerts.error(`${t('Error resetting your password')}`);
    }
    setIsLoading(false);

    modalProps.onClose();
  }

  return (
    <>
      <Modal.Header> {t('Reset Password')}</Modal.Header>
      <ContentLoader message={t('Sending password reset email')} show={isLoading} />

      <Modal.Body css={{ paddingTop: theme.spacing(1) }}>
        <EmailField {...fieldProps} label='Email' name={t('email')} placeholder={t('Enter email')} />
      </Modal.Body>

      <Modal.Actions
        disablePrimary={isLoading || fieldProps['aria-invalid'] || !fieldProps.value}
        disableSecondary={isLoading}
        onPrimaryClick={handleResetPassword}
        onSecondaryClick={modalProps.onClose}
        primaryLabel={t('Submit')}
        secondaryLabel={t('Cancel')}
      />
    </>
  );
};
